import comp from '../components/barrel';
import svg from '../js/svg';

const EP = 'application/my-app-list';
const COL_COUNT = 12;

const HEADERS = [
  '',
  'Status',
  'Will number',
  'Testament',
  'App type',
  'Offshore will',
  'Party 1',
  'Party 2',
  'Advisor',
  'Organisation',
  'Created',
  'Updated',
];

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

function ynText(val) {
  if (val === true || val === 'true' || val === 1) return 'Yes';
  if (val === false || val === 'false' || val === 0) return 'No';
  return '—';
}

async function dateText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDate(val);
}

async function dateTimeText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDateTime(val);
}

export default {
  async prepare() {
    this.recipe.methods.push(await O.mPOST(EP, {}));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    this.buildTableHead();
    const listRes = data[EP] || {};
    if (listRes.status && String(listRes.status).toUpperCase() === 'FAILED') {
      const err = (listRes.data && listRes.data.error) || 'Unable to load your wills';
      await this.buildTableBody([], err);
      this.showRecordCount(0);
      return;
    }
    const rows = Array.isArray(listRes.data) ? listRes.data : [];
    await this.buildTableBody(rows);
    this.showRecordCount(rows.length);
  },

  buildTableHead() {
    const tableHead = U.id('myWillsTableHead');
    if (!tableHead) return;
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();
    HEADERS.forEach((label, i) => {
      const cell = headRow.insertCell(i);
      cell.textContent = label;
    });
  },

  async buildTableBody(listData, emptyMessage) {
    const tbody = U.id('myWillsTableBody');
    if (!tbody) return;
    tbody.innerHTML = '';

    if (!listData.length) {
      const tr = tbody.insertRow();
      const cell = tr.insertCell(0);
      cell.colSpan = COL_COUNT;
      cell.textContent = emptyMessage || 'No wills found.';
      return;
    }

    for (const row of listData) {
      const tr = tbody.insertRow();

      const openCell = tr.insertCell(0);
      if (row.application_uuid) {
        const linkSVG = svg.linkNewPage();
        linkSVG.style.cursor = 'pointer';
        linkSVG.setAttribute('role', 'button');
        linkSVG.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          O.PREP('ViewApplication', `application_uuid=${row.application_uuid}`);
        });
        openCell.appendChild(linkSVG);
      }

      const statusCell = tr.insertCell(1);
      if (cellText(row.status)) {
        statusCell.appendChild(await comp.statusTag(row.status));
      } else {
        statusCell.textContent = '—';
      }

      tr.insertCell(2).textContent = cellText(row.importwillnumber) || '—';
      tr.insertCell(3).textContent = cellText(row.testament) || '—';
      tr.insertCell(4).textContent = cellText(row.app_type) || '—';
      tr.insertCell(5).textContent = ynText(row.offshore_will);
      tr.insertCell(6).textContent = cellText(row.party1_names) || '—';
      tr.insertCell(7).textContent = cellText(row.party2_names) || '—';
      tr.insertCell(8).textContent = cellText(row.advisor) || '—';
      tr.insertCell(9).textContent = cellText(row.organisation) || '—';
      tr.insertCell(10).textContent = await dateText(row.created_date);
      tr.insertCell(11).textContent = await dateTimeText(row.updated_date);
    }
  },

  showRecordCount(count) {
    const el = U.id('myWillsTotalRecordsDisplay');
    if (el) el.textContent = count;
  },
};
